// extracted by mini-css-extract-plugin
export var table = "_tu-0";